<template>
    <button @click.prevent="reset" class="plain-button md:absolute md:mr-6 md:mt-6 mb-6 pin-t pin-r mg-color-accent-2 hover:mg-color-accent-2-light">
        <svg class="mg-icon mg-icon--medium">
            <use href="#icon-reset" xlink:href="#icon-reset" />
        </svg>
    </button>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
export default {
    props: ["type"],
    name: "card-feed-reset",
    methods: {
        ...mapMutations(["resetNewsFilter"]),
        ...mapActions(["getNewsroomFeed"]),
        reset() {
            if (this.type == "newsroom") {
                this.resetNewsFilter();
                this.getNewsroomFeed();
            }
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/js/vue-components/card-feed-reset.vue